import {bezierEdge} from '../model'

// Action about edges data

export interface InitEdgesAction {
    type: "INIT_EDGES";
    initialState: Array<bezierEdge>;
}

export const initEdges = (initialState: Array<bezierEdge>): InitEdgesAction => ({
    type: "INIT_EDGES",
    initialState,
});

export type EdgesAction = InitEdgesAction;


export interface SetSelectedEdgesAction {
    type: "INIT_SELECTED_EDGES";
    newState: Array<number>;
}

export const setSelectedEdges = (newState: Array<number>): SetSelectedEdgesAction => ({
    type: "INIT_SELECTED_EDGES",
    newState: newState,
});

export type SelectedEdgesAction = SetSelectedEdgesAction;


export interface SwitchEdgesTypeAction {
    type: "SWITCH_EDGES_TYPE";
}

export const switchEdgesType = (): SwitchEdgesTypeAction => ({
    type: "SWITCH_EDGES_TYPE",
});

export type EdgesTypeAction = SwitchEdgesTypeAction;


export interface SetEdgesTensionAction {
    type: "SET_EDGES_TENSION";
    newState: number;
}

export const setEdgesTension = (newState: number = 100): SetEdgesTensionAction => ({
    type: "SET_EDGES_TENSION",
    newState: newState
});

export type EdgesTension = SetEdgesTensionAction;

export interface SetHalfSelectedEdgesAction {
    type: "SET_HALF_SELECTED_EDGES";
    newState: Array<number>;
}

export const setHalfSelectedEdges = (newState: Array<number>): SetHalfSelectedEdgesAction => ({
    type: "SET_HALF_SELECTED_EDGES",
    newState,
});

export type HalfSelectedEdgesAction = SetHalfSelectedEdgesAction;